import styled from '@emotion/styled';
import Xbutton from '@/components/Record/SubjectContent/Xbutton';
import { Relation } from '@/types/api';
import { useTranslation } from 'react-i18next';

type P = {
  item: Relation;
  onDelete?: () => void;
  isFocused?: boolean;
};

const Item = ({ item, onDelete, isFocused }: P) => {
  const { t } = useTranslation();
  const isApproval = item.type === 'approval';
  const handleClick = () => {
    if (item.link) {
      window.open(item.link, '_blank');
    }
  };

  return (
    <Container
      isApproval={isApproval}
      isFocused={isFocused}
      onClick={handleClick}
    >
      <StyledMode isApproval={isApproval}>
        {isApproval ? t('품의') : t('회의록')}
      </StyledMode>
      <StyledTitle>{item.name}</StyledTitle>
      {onDelete && <Xbutton onClick={onDelete} />}
    </Container>
  );
};
export default Item;

const Container = styled.button<{ isApproval: boolean; isFocused?: boolean }>`
  display: flex;
  align-items: flex-start;
  padding: 4px;
  border-radius: 4px;
  border: ${({ isApproval }) =>
    isApproval
      ? '1px solid rgba(0, 102, 204, 0.24) '
      : '1px solid rgba(199, 122, 196, 0.24)'};
  background-color: ${({ isFocused }) => (isFocused ? '#e8e8e8' : 'var(--dk-bg-subtle, #f9fafb)')};
`;

const StyledMode = styled.div<{ isApproval: boolean }>`
  color: ${({ isApproval }) => (isApproval ? 'var(--dk-accent, #06C)' : '#c77ac4')};
  text-overflow: ellipsis;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px; /* 133.333% */
  white-space: nowrap;
`;

const StyledTitle = styled.div`
  overflow: hidden;
  color: var(--dk-text, #000);
  text-overflow: ellipsis;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  padding: 0 4px;
  text-align: start;
`;
